export const PHONE_PLACEHOLDER = '+1 (800) 000-0000'

const PHONE_SAFE_CHARS = /[^\d\s\-()]/g
const PHONE_MAX_STORED_LENGTH = 20

export function parseToDisplay(stored: string): string {
	if (!stored) return ''
	const dashIndex = stored.indexOf('-')
	if (dashIndex === -1) {
		if (stored.startsWith('+')) return stored
		return `+${stored}`
	}
	const code = stored.slice(0, dashIndex)
	const number = stored.slice(dashIndex + 1)
	if (!code || !number) return stored
	return `+${code} ${number}`
}

export function parseToStorage(display: string): string {
	if (!display) return ''
	const withoutPlus = display.startsWith('+') ? display.slice(1) : display
	const spaceIndex = withoutPlus.indexOf(' ')
	if (spaceIndex === -1) {
		return withoutPlus
			.replace(PHONE_SAFE_CHARS, '')
			.slice(0, PHONE_MAX_STORED_LENGTH)
	}
	const code = withoutPlus.slice(0, spaceIndex)
	const number = withoutPlus.slice(spaceIndex + 1)
	if (!code || !number) {
		return withoutPlus
			.replace(PHONE_SAFE_CHARS, '')
			.slice(0, PHONE_MAX_STORED_LENGTH)
	}
	return `${code}-${number}`
		.replace(PHONE_SAFE_CHARS, '')
		.slice(0, PHONE_MAX_STORED_LENGTH)
}
